import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAll,
} from "../../../../features/admin/master/vehicletype/Slice";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Reject_Modal from "../../../common-components/common_Modal/Reject_Modal/Reject_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [rejectModalShow, setRejectModalShow] = React.useState(false);

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();
  const imageFile = watch("image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        reset(res?.payload?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("bonus", data?.bonus);
      sendData.append("minimum_km", data?.minimum_km);
      sendData.append("minimum_km_fare", data?.minimum_km_fare);
      sendData.append("free_ride_driver_bonus", data?.free_ride_driver_bonus);

      // sendData.append("image", data?.image[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }

      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({ name: "" });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
        setRejectModalShow(true);
        setTimeout(() => {
          setRejectModalShow(false);
        }, 3000);
      } else {
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };
  return (
    <>
      <Add_section_title
        title={id ? "Edit Vehicle Type" : "Add Vehicle Type"}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Name"
                  {...register("name", {
                    required: "Name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.name && (
                  <span className="text-danger">{errors.name?.message}</span>
                )}
              </div>
            </div>
            {/* <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("image") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className=" form-groupmb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div> */}
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-group mb-3"
                controlId="formBasicBonus"
              >
                <Form.Label>Bonus</Form.Label>

                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Enter Bonus"
                  className={classNames("", {
                    "is-invalid": errors?.bonus,
                  })}
                  {...register("bonus", {
                    required: "Bonus is required",
                    valueAsNumber: true,
                    min: {
                      value: 0,
                      message: "Bonus cannot be negative",
                    },
                    validate: (value) =>
                      /^\d+(\.\d{1,2})?$/.test(value) ||
                      "Enter valid amount (maximum 2 decimal places)",
                  })}
                />

                {errors?.bonus && (
                  <Form.Text className="text-danger">
                    {errors.bonus.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-group mb-3"
                controlId="formBasicFreeRideDriverBonus"
              >
                <Form.Label>Free Ride Driver Bonus</Form.Label>

                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Enter Free Ride Driver Bonus"
                  className={classNames("", {
                    "is-invalid": errors?.free_ride_driver_bonus,
                  })}
                  {...register("free_ride_driver_bonus", {
                    required: "Free Ride Driver Bonus is required",
                    valueAsNumber: true,
                    min: {
                      value: 0,
                      message: "Free Ride Driver Bonus cannot be negative",
                    },
                    validate: (value) =>
                      /^\d+(\.\d{1,2})?$/.test(value) ||
                      "Enter valid amount (maximum 2 decimal places)",
                  })}
                />

                {errors?.free_ride_driver_bonus && (
                  <Form.Text className="text-danger">
                    {errors.free_ride_driver_bonus.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            {/* Free KM */}
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-group mb-3"
                controlId="formBasicFreeRideDriverBonus"
              >
                <Form.Label>Minimum KM</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Minimum KM (e.g. 2.50)"
                  {...register("minimum_km", {
                    required: "Minimum KM is required",
                    valueAsNumber: true,
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.minimum_km,
                  })}
                />
                {errors.minimum_km && (
                  <span className="text-danger">
                    {errors.minimum_km?.message}
                  </span>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-group mb-3"
                controlId="formBasicFreeRideDriverBonus"
              >
                <Form.Label>Minimum KM Fare</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  placeholder="Minimum KM Fare (e.g. 2.50)"
                  {...register("minimum_km_fare", {
                    required: "Minimum KM Fare is required",
                    valueAsNumber: true,
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.minimum_km_fare,
                  })}
                />
                {errors.minimum_km_fare && (
                  <span className="text-danger">
                    {errors.minimum_km_fare?.message}
                  </span>
                )}
              </Form.Group>
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({ name: "" });
                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <Successfull_Modal
        message={"Vehicle Type Added Successfully"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />{" "}
      <Reject_Modal
        message={"Vehicle Type Already Exist"}
        show={rejectModalShow}
        onHide={() => setRejectModalShow(false)}
      />
    </>
  );
};

export default Add;
